import p1 from '../../../../assets/images/marketing_Agent/pillar1.png';
import p2 from '../../../../assets/images/marketing_Agent/pillar2.png';
import p3 from '../../../../assets/images/marketing_Agent/pillar3.png';
import { Head, Section } from './ui';
const pillars = [
  [p1, 'bg-soft', 'Build Your Network', 'Connect verified consumers and authentic shops to the platform, create reliable, thriving marketplace connections in your region', 'Verified Expansion', 'diagram-3'],
  [p2, 'bg-warning-subtle', 'Achieve Your Star Rank', 'Meet cumulative qualified user counts and registered business quotas simultaneously to step up through the 10 Star hierarchy', 'Dual-Metric Matrix', 'award'],
  [p3, 'bg-soft', 'Unlock Earning Opportunities', 'Eligible commission rates scale up from 5% to 20% alongside acquisition rewards and performance incentives from verified transaction volume', 'Volume-Based Yield', 'cash-coin'],
];
export default function EcosystemFoundation() {
  return (
    <Section bg="bg-soft">
      <Head pill="Ecosystem foundation" title="Build a genuine network, create real value" text="The SELECTEZI Star System rewards active, verified marketplace engagement. Success is measured by long-term ecosystem retention, verified commerce, and sustainable growth." />
      <div className="row g-4 align-items-start">
        {pillars.map(([img, bg, t, d, f, ic], i) => (
          <div className="col-md-4" key={t}>
            <div className="card-soft p-3 h-100">
              <div className={`${bg} rounded-3 p-3 text-center mb-3`}><img src={img} alt="" className="img-fluid" style={{ height: 120, objectFit: 'contain' }} /></div>
              <div className="t-xs fw-bold text-muted2 text-uppercase">Ecosystem pillar 0{i + 1}</div>
              <h5 className="fw-bold">{t}</h5>
              <p className="t-sm text-muted2">{d}</p>
              <div className="border-top pt-3 d-flex justify-content-between text-blue fw-bold t-xs"><span>{f}</span><i className={`bi bi-${ic}`} /></div>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-navy text-white rounded-4 p-4 p-md-5 mt-5 row g-4 align-items-center mx-0">
        <div className="col-lg-9">
          <div className="text-gold fw-bold t-xs text-uppercase">Core governing principle</div>
          <h4 className="fw-bold text-uppercase my-2">“Stars measure the strength of your network, commissions measure the value your network creates”</h4>
          <p className="t-sm mb-0 text-white-50">An explicit operational distinction: Star Rank reflects your verified network footprint, whereas commissions correspond to actual settled volume.</p>
        </div>
        <div className="col-lg-3 d-flex gap-3">
          {[['100%', 'Audit verified'], ['5%–20%', 'Tier rates']].map(([a, b]) => (
            <div key={a} className="bg-navy2 rounded-3 p-3 text-center flex-fill"><div className="text-gold fw-bold t-lg">{a}</div><div className="t-xs fw-bold text-uppercase">{b}</div></div>
          ))}
        </div>
      </div>
    </Section>
  );
}
